/* eslint-disable no-useless-concat */
import { Color, calculateShade, hexToRGBAString } from '@nect/ui/theme/color';
import React from 'react';
import { ThemeProvider } from 'styled-components';

import { GlobalStyle, heebo, poppins } from './global';

const nectGreen = '03AFA7';
const primaryBlue = '2F80ED';
const primaryPurple = '646EE5';
const primaryRed = 'D33367';
const primaryOrange = 'F8A427';

export const NectDefaultColor = {
    // Nect Green
    [Color.nectGreenOpacity5]: hexToRGBAString(nectGreen, 0.05),
    [Color.nectGreen100]: calculateShade(nectGreen, 100),
    [Color.nectGreen200]: calculateShade(nectGreen, 200),
    [Color.nectGreen300]: calculateShade(nectGreen, 300),
    [Color.nectGreen400]: calculateShade(nectGreen, 400),
    [Color.nectGreen500]: calculateShade(nectGreen, 500),
    [Color.nectGreen600]: calculateShade(nectGreen, 600),
    [Color.nectGreen700]: calculateShade(nectGreen, 700),
    [Color.nectGreen800]: calculateShade(nectGreen, 800),
    [Color.nectGreen900]: calculateShade(nectGreen, 900),

    // Primary Blue
    [Color.primaryBlueOpacity5]: hexToRGBAString(primaryBlue, 0.05),
    [Color.primaryBlue100]: calculateShade(primaryBlue, 100),
    [Color.primaryBlue200]: calculateShade(primaryBlue, 200),
    [Color.primaryBlue300]: calculateShade(primaryBlue, 300),
    [Color.primaryBlue400]: calculateShade(primaryBlue, 400),
    [Color.primaryBlue500]: calculateShade(primaryBlue, 500),
    [Color.primaryBlue600]: calculateShade(primaryBlue, 600),
    [Color.primaryBlue700]: calculateShade(primaryBlue, 700),
    [Color.primaryBlue800]: calculateShade(primaryBlue, 800),
    [Color.primaryBlue900]: calculateShade(primaryBlue, 900),

    // Primary Purple
    [Color.primaryPurpleOpacity5]: hexToRGBAString(primaryPurple, 0.05),
    [Color.primaryPurple100]: calculateShade(primaryPurple, 100),
    [Color.primaryPurple200]: calculateShade(primaryPurple, 200),
    [Color.primaryPurple300]: calculateShade(primaryPurple, 300),
    [Color.primaryPurple400]: calculateShade(primaryPurple, 400),
    [Color.primaryPurple500]: calculateShade(primaryPurple, 500),
    [Color.primaryPurple600]: calculateShade(primaryPurple, 600),
    [Color.primaryPurple700]: calculateShade(primaryPurple, 700),
    [Color.primaryPurple800]: calculateShade(primaryPurple, 800),
    [Color.primaryPurple900]: calculateShade(primaryPurple, 900),

    // Primary Red
    [Color.primaryRedOpacity5]: hexToRGBAString(primaryRed, 0.05),
    [Color.primaryRed100]: calculateShade(primaryRed, 100),
    [Color.primaryRed200]: calculateShade(primaryRed, 200),
    [Color.primaryRed300]: calculateShade(primaryRed, 300),
    [Color.primaryRed400]: calculateShade(primaryRed, 400),
    [Color.primaryRed500]: calculateShade(primaryRed, 500),
    [Color.primaryRed600]: calculateShade(primaryRed, 600),
    [Color.primaryRed700]: calculateShade(primaryRed, 700),
    [Color.primaryRed800]: calculateShade(primaryRed, 800),
    [Color.primaryRed900]: calculateShade(primaryRed, 900),

    // Primary Orange
    [Color.primaryOrangeOpacity5]: hexToRGBAString(primaryOrange, 0.05),
    [Color.primaryOrange100]: calculateShade(primaryOrange, 100),
    [Color.primaryOrange200]: calculateShade(primaryOrange, 200),
    [Color.primaryOrange300]: calculateShade(primaryOrange, 300),
    [Color.primaryOrange400]: calculateShade(primaryOrange, 400),
    [Color.primaryOrange500]: calculateShade(primaryOrange, 500),
    [Color.primaryOrange600]: calculateShade(primaryOrange, 600),
    [Color.primaryOrange700]: calculateShade(primaryOrange, 700),
    [Color.primaryOrange800]: calculateShade(primaryOrange, 800),
    [Color.primaryOrange900]: calculateShade(primaryOrange, 900),

    // Greys
    [Color.grey100]: '#FAFBFC',
    [Color.grey200]: '#F0F1F2',
    [Color.grey300]: '#DDDEE0',
    [Color.grey400]: '#A9ABB0',
    [Color.grey500]: '#797C81',
    [Color.grey600]: '#4B4F55',
    [Color.grey700]: '#0A0D1B',

    // Whites
    [Color.white100]: '#FFFFFF',
    [Color.white90]: 'rgba(255, 255, 255, 0.9)',
    [Color.white80]: 'rgba(255, 255, 255, 0.8)',
    [Color.white70]: 'rgba(255, 255, 255, 0.7)',
    [Color.white60]: 'rgba(255, 255, 255, 0.6)',
    [Color.white50]: 'rgba(255, 255, 255, 0.5)',
    [Color.white40]: 'rgba(255, 255, 255, 0.4)',
    [Color.white30]: 'rgba(255, 255, 255, 0.3)',
    [Color.white20]: 'rgba(255, 255, 255, 0.2)',
    [Color.white10]: 'rgba(255, 255, 255, 0.1)',
    [Color.white5]: 'rgba(255, 255, 255, 0.05)',
    [Color.white1]: 'rgba(255, 255, 255, 0.01)',

    // Blacks
    [Color.black100]: '#000000',
    [Color.black90]: 'rgba(0, 0, 0, 0.9)',
    [Color.black80]: 'rgba(0, 0, 0, 0.8)',
    [Color.black70]: 'rgba(0, 0, 0, 0.7)',
    [Color.black60]: 'rgba(0, 0, 0, 0.6)',
    [Color.black50]: 'rgba(0, 0, 0, 0.5)',
    [Color.black40]: 'rgba(0, 0, 0, 0.4)',
    [Color.black30]: 'rgba(0, 0, 0, 0.3)',
    [Color.black20]: 'rgba(0, 0, 0, 0.2)',
    [Color.black10]: 'rgba(0, 0, 0, 0.1)',
    [Color.black5]: 'rgba(0, 0, 0, 0.05)',
    [Color.black1]: 'rgba(0, 0, 0, 0.01)',

    // Others
    [Color.otherPearl]: '#FBE1CE',
    [Color.otherApple]: '#C7F1DC',
    [Color.otherLilac]: '#BABFFF',
    [Color.otherMauve]: '#EDCEFF',
    [Color.otherMilkTea]: '#FFD4D4',
    [Color.otherHoney]: '#F5D424',

    // Snacks
    [Color.snackSuccessPad]: '#F0FDFB',
    [Color.snackSuccessBase]: '#11C6B0',

    [Color.snackInfoPad]: '#F2F9FF',
    [Color.snackInfoBase]: '#0A6CFF',

    [Color.snackErrorPad]: '#FFF2F3',
    [Color.snackErrorBase]: '#F01C4F',

    [Color.snackWarning1Pad]: '#FFF7F1',
    [Color.snackWarning1Base]: '#FF6F07',

    [Color.snackWarning2Pad]: '#F7F4FF',
    [Color.snackWarning2Base]: '#5820F8',
};

export const NectDefaultTheme = {
    name: 'Nect Default',

    heading: {
        fontFamily: `${poppins.style.fontFamily}, sans-serif`,
        color: {
            default: NectDefaultColor[Color.grey700],
        },
    },
    button: {
        fontFamily: `${poppins.style.fontFamily}, sans-serif`,
        color: {
            default: NectDefaultColor[Color.grey700],
        },
    },
    text: {
        fontFamily: `${heebo.style.fontFamily}, sans-serif`,
        color: {
            default: NectDefaultColor[Color.grey700],
        },
    },
    table: {
        fontFamily: `${poppins.style.fontFamily}, sans-serif`,
        color: {
            default: NectDefaultColor[Color.grey700],
        },
    },

    color: {
        ...NectDefaultColor,
    },

    borderRadius: {
        /**  @size None */
        None: '0',
        /**  @size 4px */
        XS: '4px',
        /**  @size 8px */
        S: '8px',
        /**  @size 16px */
        M: '16px',
        /**  @size 24px */
        L: '24px',
        /**  @size 9999px */
        Round: '9999px',
        /**  @size 50% */
        Ellipse: '50%',
    },
    spacing: {
        /**  @size 4px */
        XXXS: '4px',
        /**  @size 8px */
        XXS: '8px',
        /**  @size 12px */
        XS: '12px',
        /**  @size 16px */
        S: '16px',
        /**  @size 24px */
        M: '24px',
        /**  @size 32px */
        L: '32px',
        /**  @size 40px */
        XL: '40px',
        /**  @size 64px */
        XXL: '64px',
        /**  @size 128px */
        XXXL: '128px',
    },
    elevation: {
        shadow: {
            1: '0px 1px 3px',
            2: '0px 2px 6px',
            3: '0px 8px 16px',
            4: '0px 12px 24px',
        },
        color: {
            light: {
                1: 'rgba(0, 6, 19, 0.08)',
                2: 'rgba(0, 6, 19, 0.1)',
                3: 'rgba(0, 0, 0, 0.08)',
                4: 'rgba(0, 0, 0, 0.08)',
            },
            dark: {
                1: '#010205',
                2: 'rgba(1, 2, 5, 0.8)',
                3: 'rgba(1, 2, 5, 0.72)',
                4: 'rgba(1, 2, 5, 0.72)',
            },
            nectGreen: {
                1: 'rgba(0, 95, 90, 0.4)',
                2: 'rgba(0, 95, 90, 0.32)',
                3: 'rgba(0, 95, 90, 0.16)',
                4: 'rgba(0, 95, 90, 0.16)',
            },
            invertNectGreen: {
                1: 'rgba(131, 194, 191, 0.24)',
                2: 'rgba(131, 194, 191, 0.16)',
                3: 'rgba(131, 194, 191, 0.16)',
                4: 'rgba(131, 194, 191, 0.24)',
            },
        },
    },
    breakpoint: {
        mobile: {
            min: '0px',
            max: '767px',
        },
        tablet: {
            min: '768px',
            max: '1279px',
        },
        desktop: {
            min: '1280px',
        },
    },
    container: {
        desktop: '1184px',
    },
};

export type IThemeNectDefault = typeof NectDefaultTheme;

export const NectStyleProvider = ({
    // theme,
    children,
}: {
    // theme: IThemeNectDefault;
    children: React.ReactNode;
}) => {
    return (
        <ThemeProvider theme={NectDefaultTheme}>
            <GlobalStyle>{children}</GlobalStyle>
        </ThemeProvider>
    );
};
